/*
 *
 * ----------------------------------------------- */
jQuery(function ($) {
  // document.addEventListener(
  //   "wpcf7mailsent",
  //   function (event) {
  //     $(".expert-form .modal").addClass("open");
  //   },
  //   false
  // );

  // $(".popup .modal").addClass("open");

  $(".modal .close-btn").on("click", function () {
    $(this).closest(".modal").removeClass("open");
  });

  $(".section-fixed-cta .btn-close").on("click", function () {
    $(this).closest(".section-fixed-cta").hide();
  });

  $("select[name=consultation] option:first").attr("disabled", "disabled");

  jQuery(function ($) {
    if (
      $("body").hasClass("page-id-11") ||
      $("body").hasClass("page-id-87") ||
      $("body").hasClass("single")
    ) {
      // var url = "";
      $(".page-id-11 a, .page-id-87 a, .single a").addClass("open-modal");

      $(".page-id-11 a, .page-id-87 a, .single a")
        .not(".close-btn")
        .on("click", function (e) {
          // var url = $(this).attr("href");
          if (
            $(".page-id-11 a, .page-id-87 a, .single a").hasClass("open-modal")
          ) {
            e.preventDefault();
            $(".modal").addClass("open");

            $(".page-id-11 a, .page-id-87 a, .single a").removeClass(
              "open-modal"
            );
          }
        });

      // $(".modal .close-btn").on("click", function () {
      //   console.log("pressed");
      // });

      sessionStorage.setItem("line_exit_popup_flg", "1");
      // console.log(sessionStorage.getItem("line_exit_popup_flg"));
      if (sessionStorage.getItem("line_exit_popup_flg") === "1") {
        history.pushState(null, null, null);
        $(window).on("popstate", function () {
          $(".modal").addClass("open");
        });
        $(".modal .close-btn").on("click", function () {
          sessionStorage.setItem("line_exit_popup_flg", "0");
          // console.log(sessionStorage.getItem("line_exit_popup_flg"));
        });
      }
    }
  });
});
